import React, { useState } from 'react';
import { Phone, Mail, Clock, MapPin, ChevronDown, MessageCircle } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import PackagesSection from '../components/PackagesSection';
import BookingSection from '../components/BookingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  // Track page visit on component mount
  React.useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${BACKEND_URL}/api/analytics/visit?page=home`);
      } catch (error) {
        console.log('Analytics tracking failed:', error);
        // Silently fail - don't disrupt user experience
      }
    };
    
    trackVisit();
  }, []);

  return (
    <div className="min-h-screen">
      {/* Fixed Header */}
      <header className="header-nav">
        <div className="container">
          <div className="flex items-center justify-between w-full" style={{ gap: '1rem', margin: '0', padding: '0' }}>
            <div className="flex items-center justify-center w-full md:w-auto" style={{ margin: '0', padding: '0' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_mobile-medcare/artifacts/qw02dc4c_liftapp%20%281%29.png" 
                alt="Medic on the Move" 
                className="logo"
                style={{ 
                  height: '175px', 
                  width: 'auto', 
                  maxWidth: '100%', 
                  display: 'block', 
                  margin: '0', 
                  padding: '0'
                }}
              />
            </div>
            
            <nav className="hidden lg:flex items-center" style={{ gap: '1.5rem' }}>
              <a href="#about" className="nav-link">About</a>
              <a href="#services" className="nav-link">Services</a>
              <a href="#packages" className="nav-link">Packages</a>
              <a href="#testimonials" className="nav-link">Testimonials</a>
              <a href="#contact" className="nav-link">Contact</a>
            </nav>

            <div className="flex items-center w-full md:w-auto justify-center md:justify-end" style={{ gap: '1rem' }}>
              <a href="https://wa.me/27674933211" target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center gap-2 text-sm">
                <Phone size={16} />
                <MessageCircle size={16} />
                <span className="mono-text">067 493 3211</span>
              </a>
              <a href="#booking" className="btn-primary">
                Book Appointment
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PackagesSection />
      <BookingSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
